import * as React from 'react';
export const IcKiranaStore = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17 3H7a3 3 0 00-3 3v4a1 1 0 001 1 2.62 2.62 0 001.82-.74c.25-.22.31-.26.52-.26.21 0 .26 0 .51.26a2.62 2.62 0 001.82.74 2.58 2.58 0 001.82-.74c.26-.22.31-.26.52-.26.21 0 .26 0 .51.26a2.61 2.61 0 003.64 0c.25-.22.3-.26.51-.26.21 0 .26 0 .51.26A2.62 2.62 0 0019 11a1 1 0 001-1V6a3 3 0 00-3-3zM20 19h-1v-6a4.47 4.47 0 01-2-.46V15H7v-2.46A4.47 4.47 0 015 13v6H4a1 1 0 000 2h16a1 1 0 000-2z'
      fill='currentColor'
    />
  </svg>
);
